import { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./type";
import SugarBlast2Utils from "./utils";

export const SugarBlastRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  const candyPayouts = Object.entries(payouts);
  const halfCandyCount = candyPayouts.length / 2;
  const payoutElement = [
    <tr key={2} className="text-center">
      {candyPayouts.slice(halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {SugarBlast2Utils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
    <tr key={1} className="text-center">
      {candyPayouts.slice(0, halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {SugarBlast2Utils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
  ];
  const specialSymbols = [
    <tr key={1} className="text-center">
      {[4, 2, 3].map((symbol) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {SugarBlast2Utils.convertSymbol(+symbol)}
          </div>
        </td>
      ))}
    </tr>,
  ];
  return (
    <>
      <h5 className="card-title">Game Rules</h5>
      <div className="card-text">
        <h6>Payout Table</h6>
        <br />
        <table className="w-100">
          <tbody>{payoutElement}</tbody>
        </table>
      </div>
      <p className="card-text">
        Match four or more candies for a win!
        <br />
        Matched candies explode and trigger a cascade of new symbols.
      </p>
      <p className="card-text">
        Scoring continues until no further matches are possible.
      </p>
      <p className="card-text">Malfunction voids all wins and plays</p>
      <h6>Free Spin Meter</h6>
      <p className="card-text">
        During a round, a match progresses the free spin bar by 1.
        <br />
        Collecting 3 yellow candies on the free spin bar awards free spins and
        subsequent matches continue to advance the bar until the maximum is
        reached.
        <br />
      </p>
      <h6>Buy Free Spins</h6>
      <p className="card-text">
        <br />
        <img src="/sb2/buyfreespins.png" alt="buyfreespins" />
        <br />
        Pay 50x your total bet to trigger Free Spin Mode with at least 5 free
        spins and a chance for more!
      </p>
      <h6>Free Spin Mode</h6>
      <p className="card-text">
        Free spins are rewarded equal to the threshold reached on the Free Spin
        Meter.
        <br />
        During free spin, all wins are 2x of a regular round's payout.
        <br />
        During free spin, Sugar blast wins are 10x of a regular round's payout.
      </p>
      <h6>Sugar Blast</h6>
      <p className="card-text">
        Combining three or more special symbols initiates Sugar Blast, removing
        all symbols.
        <br /> <br />
        In normal spin, Sugar Blast awards 2x payout.
        <br />
        In free spin, Sugar Blast awards 10x payout.
      </p>
      {/* <table className="w-100">
        <tbody>{specialSymbols}</tbody>
      </table> */}
      <p className="card-text">
        During a round, each respin or successful combination increases the
        progress bar for free spins.
      </p>
      <br />
      <h6>Special Symbols</h6>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+4)}
      </div>
      Kola Rocket
      <p>
        Combining five identical candy symbols horizontally or vertically forms
        a Kola Rocket.
        <br />
        It destroys all candies in a line.
      </p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+3)}
      </div>
      Cocoa Bomb
      <p>
        Combining six identical candy symbols horizontally or vertically forms a
        Cocoa Bomb.
        <br />
        It destroys candies within one tile radius.
      </p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+2)}
      </div>
      Random Candy
      <p>
        Combining seven identical candy symbols horizontally or vertically forms
        a Random Candy.
        <br />
        It randomly selects one candy symbol type and destroys it.
      </p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+4)}
      </div>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+4)}
      </div>
      Kola Rocket + Kola Rocket
      <p>
        Combining seven identical candy symbols horizontally or vertically forms
        a Random Candy.
      </p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+4)}
      </div>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+3)}
      </div>
      Kola Rocket + Cocoa Bomb
      <p>Symbols across three rows and columns are destroyed.</p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+4)}
      </div>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+2)}
      </div>
      Kola Rocket + Random Candy
      <p>
        A candy symbol type is randomly selected and destroyed, along with
        symbols in a row and column where the combination was located.
      </p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+3)}
      </div>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+3)}
      </div>
      Cocoa Bomb + Cocoa Bomb
      <p>All symbols within a 5x5 area are destroyed.</p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+3)}
      </div>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+4)}
      </div>
      Cocoa Bomb + Random Candy
      <p>
        A randomly chosen symbol type and all symbols in a diamond shape around
        them are destroyed.
      </p>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+3)}
      </div>
      <div className="d-inline-block symbol">
        {SugarBlast2Utils.convertSymbol(+2)}
      </div>
      Random Candy + Random Candy
      <p>All instances of three randomly chosen symbols are destroyed.</p>
    </>
  );
};
